module.exports = __webpack_public_path__ + "static/media/nodejs.05108f13.svg";